<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn flat v-on="on" class="lp-outline-panel-actions-button">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-tile @click="selectFromContentManager(termType)">
        <v-list-tile-title class="body-1">
          <v-layout row align-center>
            <v-icon class="mr-2">mdi-plus</v-icon>
            <span>Add term</span>
          </v-layout>
        </v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="selectFromContentManager(glossaryType)">
        <v-list-tile-title class="body-1">
          <v-layout row align-center>
            <v-icon class="mr-2">mdi-book-alphabet</v-icon>
            <span>Import glossary</span>
          </v-layout>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import PServiceContent from "plant-common/src/services/PServiceContent"
import { Extensions } from "plant-common"

export default {
  name: "ContentSelectionMenu",
  data() {
    return {
      termType: Extensions.term.name,
      glossaryType: Extensions.glossary.name,
    }
  },
  methods: {
    async selectFromContentManager(filterType) {
      const selectedContent = await this.selectContent(filterType)

      if (!selectedContent.length) return

      this.$emit("content-selected", selectedContent)
    },
    async selectContent(filterType) {
      const allowMultipleSelection = filterType === this.termType

      let selectedContent = await PServiceContent.selectContent({
        type: filterType,
        multipleSelection: allowMultipleSelection
      })

      if (!selectedContent) return []

      return Array.isArray(selectedContent) ? selectedContent : [selectedContent]
    }
  }
}
</script>
